import script from "./LinksField.vue?vue&type=script&lang=ts&setup=true"
export * from "./LinksField.vue?vue&type=script&lang=ts&setup=true"

import "./LinksField.vue?vue&type=style&index=0&id=7ef40f29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ef40f29"]])

export default __exports__